import { useTranslation } from "react-i18next";
import { Label } from "@tellescope/ui";
import { Select } from "@tellescope/design-system";

interface StripeAccount {
  key: string;
  title: string;
}

interface StripeAccountSelectorProps {
  accounts: StripeAccount[];
  isLoading: boolean;
  value: string | null;
  onChange: (stripeKey: string) => void;
}

/** No auto-select-when-there's-only-one, by design — the admin always picks explicitly. */
export const StripeAccountSelector = ({ accounts, isLoading, value, onChange }: StripeAccountSelectorProps) => {
  const { t } = useTranslation("shop");

  if (!isLoading && accounts.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">{t("No Stripe account is connected for this organization yet.")}</p>
    );
  }

  return (
    <div className="space-y-2">
      <Label>{t("Stripe Account")}</Label>
      <Select value={value ?? ""} onValueChange={onChange} disabled={isLoading}>
        <Select.Trigger className="w-full">
          <Select.Value placeholder={t("Select Stripe Account")} />
        </Select.Trigger>
        <Select.Content>
          {accounts.map((account) => (
            <Select.Item key={account.key} value={account.key}>
              {account.title}
            </Select.Item>
          ))}
        </Select.Content>
      </Select>
    </div>
  );
};
